import { render, staticRenderFns } from "./AutomatedKDBSchedule.vue?vue&type=template&id=640b7d16&scoped=true&"
import script from "./AutomatedKDBSchedule.vue?vue&type=script&lang=js&"
export * from "./AutomatedKDBSchedule.vue?vue&type=script&lang=js&"
import style0 from "./AutomatedKDBSchedule.vue?vue&type=style&index=0&id=640b7d16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640b7d16",
  null
  
)

export default component.exports